import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalResetConfiguration({ show, onHide, handleConfirmReset, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('Confirm Reset')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {t('Are you sure you want to reset this Configuration?')}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Cancel')}
                </Button>
                <Button variant="danger" onClick={handleConfirmReset} disabled={isLoadingButton}>
                    {isLoadingButton ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            {t('Reset')}
                        </>
                    ) : (
                        t('Reset')
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalResetConfiguration;